import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { PermissionService } from '../../services/permission/permission.service';
import { PermissionEnum, ResourceEnum } from '../../../../environments/shared-environment/permission';

@Directive({
  selector: '[lHasPermission]',
  standalone: true
})
export class HasPermission {

  constructor(
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainer: ViewContainerRef,
    private readonly permissionService: PermissionService
  ) { }

  @Input('lHasPermission')
  public set hasPermission(permissions: [ResourceEnum, PermissionEnum]) {
    this.checkPermission(permissions[0], permissions[1]);
  }

  public checkPermission(r: ResourceEnum, p: PermissionEnum): void {
    const hasPermission = this.permissionService.has(r, p);

    if (!hasPermission) {
      this.viewContainer.clear();
      return;
    }

    this.viewContainer.createEmbeddedView(this.templateRef);
  }

}
